export default {"src":"/_next/static/media/order_message.b0efccae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};